import { useSelector } from "react-redux";

import { getCartDispensaryState } from "redux/selectors/cartDispensary";

import CartTypeLabel from "../CartTypeLabel";

type Props = {
  isCartEmpty: boolean;
  isEmbedded?: boolean;
  isInStoreCart?: boolean;
};

const BagHeader = ({ isCartEmpty, isEmbedded, isInStoreCart }: Props) => {
  const dispensaryState = useSelector(getCartDispensaryState);
  const dispensaryName = dispensaryState.data?.name;
  const menuLink = dispensaryState.menuLink;
  const shouldShowDispensaryName =
    isCartEmpty === false && dispensaryName && !isEmbedded;

  return (
    <div id="bag-header" className="bg-white mb-lg p-lg ">
      <div className="container m-auto">
        <div
          data-testid="bag-header-title"
          className="heading--m font-extrabold flex items-center justify-between"
        >
          {isInStoreCart ? "In-store cart" : "Your cart"}
          <CartTypeLabel className="ml-3" />
        </div>
        {shouldShowDispensaryName && (
          <div data-testid="bag-header-subtitle" className="mt-xs text-sm">
            with&nbsp;
            <a
              href={menuLink || ""}
              className="font-bold underline text-green"
              aria-label={`Go to ${dispensaryName} page`}
            >
              {dispensaryName}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default BagHeader;
